import { render, staticRenderFns } from "./aspectList.vue?vue&type=template&id=ecc4c518"
import script from "./aspectList.vue?vue&type=script&lang=js"
export * from "./aspectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports